var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160617",
    "data-name": "Group 160617",
    transform: "translate(-1828 -553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147731",
    "data-name": "Rectangle 147731",
    transform: "translate(1828 553)",
    fill: "#f5f7f8",
    stroke: "rgba(112,112,112,0.15)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_akar-plus",
    "data-name": "Icon akar-plus",
    d: "M12,18V12m0,0V6m0,6h6m-6,0H6",
    transform: "translate(1835 560.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c35cd72ed2a7264349df10d90a4f12c5.svg";
export { ForwardRef as ReactComponent };